import merge from "lodash/merge";

import { buildSystem, defaultSystem } from "./system";
import { tokens } from "./tokens";
import type { EhqThemeOverrides } from "./tokens";

export interface ThemeConfig {
  initialColorMode: "light" | "dark";
  useSystemColorMode: boolean;
}

export const themeConfig: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false
};

export { defaultSystem, buildSystem, tokens };

export const system = defaultSystem;

export function extendTheme(...overrides: Record<string, unknown>[]) {
  return merge({}, ...overrides);
}

export const theme = extendTheme({
  breakpoints: {
    sm: "20em",
    md: "26em",
    lg: "48em",
    xl: "80em",
    "2xl": "120em"
  },
  config: themeConfig
});

export type { EhqThemeOverrides };

export function createSystemFromTheme(
  themeOverrides?: Record<string, unknown>
) {
  const { colors, fonts, fontSizes, fontWeights, radii, shadows } =
    (themeOverrides ?? {}) as EhqThemeOverrides;

  return buildSystem({
    colors: colors as EhqThemeOverrides["colors"],
    fonts,
    fontSizes,
    fontWeights,
    radii,
    shadows
  });
}
